import Axios from "axios";
// import store from "../store";
let instance = null;

const BASE_API = process.env.VUE_APP_BASE_API;

const HTTP = Axios.create({
  baseURL: BASE_API,
  headers: {
    "X-Access-Token": `${window.localStorage.getItem("accessToken")}`
  }
});

class Service {
  constructor() {
    if (!instance) instance = this;
    return instance;
  }
  //config
  updateHeaders(token) {
    Axios.defaults.headers.common["X-Access-Token"] = `${token}`;
    HTTP.defaults.headers = Axios.defaults.headers;
    window.localStorage.setItem("accessToken", token);
  }

  //BLOG
  categoriesBlog() {
    return HTTP.get(`/categories/`)
      .then(res => res)
      .catch(err => err.response);
  }

  blogPostsList() {
    return HTTP.get(`/posts`)
      .then(res => res)
      .catch(err => err.response);
  }

  blogPost(payload) {
    return HTTP.get(`/posts/${payload}`)
      .then(res => res)
      .catch(err => err.response);
  }

  //FAQ
  faq(payload) {
    return HTTP.get(`/faqs/?section=${payload}`)
      .then(res => res)
      .catch(err => err.response);
  }

  //SUPPORT
  supportModules() {
    return HTTP.get(`/modules`)
      .then(res => res)
      .catch(err => err.response);
  }
  supportModulesMainlist() {
    return HTTP.get(`/modules/mainlist`)
      .then(res => res)
      .catch(err => err.response);
  }
  supportModulesDetail({ slug }) {
    return HTTP.get(`/modules/${slug}/`)
      .then(res => res)
      .catch(err => err.response);
  }
  supportModulesFeatured() {
    return HTTP.get(`/modules/featureds`)
      .then(res => res)
      .catch(err => err.response);
  }
  supportContent(payload) {
    return HTTP.get(`/content/${payload}`)
      .then(res => res)
      .catch(err => err.response);
  }
  // supportModules(){
  //   return HTTP.get(`/modules`)
  //     .then(res => res)
  //     .catch(err => err.response);
  // }
  supportSearch(payload) {
    return HTTP.get(`/search?search=${payload}`)
      .then(res => res)
      .catch(err => err.response);
  }
}

export const api = new Service();
